import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {ModalLayout} from '@appbase/templates'
import api from '@webparts/api'
import * as accouttypes from '@account/store/types'
import { mapGetters } from 'vuex'

@Component({
  components: {
    ModalLayout    
  },
  computed: mapGetters({
    current: accouttypes.CURRENT,
}),
})
export default class BetterKolmar extends Vue {
  current!: account.TCurrent

  handleClose() {
    this.closeCurrentModal()
  }

  openLink(str:string){
      let src = window.location.origin
      if(process.env.NODE_ENV === 'production') src += '/po'
      src+=`/${str}`
      top?.window.resizeTo(710,900)
      window.open(src,'_self')
  }

  imgClick(str:string){
    api.webpartData.getReceiversList(`WHISTLE_${str}`,this.current.user.comCode).then(res=>{
      if(res && (res as any).length>0){
        if(this.isTeams){
          this.$emit('open',str)
        }
        else{
          this.openLink(str)
        }
      } 
      else{
        (window as any).alertAsync(`${this.$t("활성화_되지_않은_메뉴입니다")}\n${this.$t('그룹웨어_관리자에게_문의하세요')}`)
      }
    })

  }
}